import DashBoard from "../../components/dashBoard/DashBoard"

function DashBoardPage () {
    return (
        <>
        <DashBoard/>
        </>
    )
}
export default DashBoardPage